<template>
  <v-container fluid>
    <v-tabs v-model="currentActiveTab">
      <v-tab
        v-for="(menu, index) in menus"
        :key="index"
        :to="{ name: menu.route }"
        @click="changeActiveStatus(index)"
      >
        {{ menu.label }}
      </v-tab>
    </v-tabs>
    <router-view
      :height="height"
    />
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'TicketSupport',

  data() {
    return {
      height: 0,
      currentActiveTab: null,
    };
  },

  computed: {
    ...mapState('ticket', ['activeTab']),
    menus() {
      const menus = [
        {
          label: 'Tickets',
          route: 'tickets',
          permissions: 'view ticket',
        },

      ];

      if (this.hasPermission('view ticket::outbound')) {
        menus.push({
          label: 'Campaigns',
          route: 'ticket-campaign',
          permissions: 'view ticket',
        });
      }

      return menus;
    },
  },

  watch: {
    activeTab(newValue) {
      this.setActiveTab(newValue);
    },
  },

  methods: {
    ...mapActions('ticket', ['setActiveTab']),
    changeActiveStatus(index) {
      this.currentActiveTab = index;
      this.setActiveTab(index);
    },
  },
};
</script>

<style scoped>

</style>
